module.exports = __webpack_public_path__ + "img/snack-at-university.4914f348.svg";